const { JOURNEY_TYPE } = require("../../constants");

const getIsLOAJourneySelected = journey => journey === JOURNEY_TYPE.LOA;

module.exports = { getIsLOAJourneySelected };
